import React, { useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import SupersetDashboardEmbed from '@spark/ui-components/components/Dashboard/SupersetDashboardEmbed';
import { useSupersetDashboardToken } from '../hooks/useSupersetDashboardToken';
import PremiacaoTabelaModal from '../Premiacao/components/PremiacaoTabelaModal';
import PremiacaoTabelaVeiculoModal from '../Premiacao/components/PremiacaoTabelaVeiculoModal';
import PremiacaoInfracaoModal from '../Premiacao/components/PremiacaoInfracaoModal';
import PremiacaoInfracaoMotoristaDashboardModal from '../Premiacao/components/PremiacaoInfracaoMotoristaDashboardModal';
import PremiacaoConsolidadoModal from '../Premiacao/components/PremiacaoConsolidadoModal';
import PremiacaoAssociacaoModal from '../Premiacao/components/PremiacaoAssociacaoModal';

const DEFAULT_DASHBOARD_UUID = '08a0c70e-0304-412f-870b-123253b71aba';

const MODAL_TABELA = 'tabela';
const MODAL_FROTA = 'frota';
const MODAL_INFRACAO = 'infracao';
const MODAL_INFRACAO_MOTORISTA = 'infracao-motorista';
const MODAL_CONSOLIDADO = 'consolidado';
const MODAL_ASSOCIACAO = 'associacao';

const getDashboardUuidFromEnv = (envValue, fallback) => {
  const normalized = String(envValue || '').trim();
  return normalized || fallback;
};

const DashboardPremiacaoMain = () => {
  const [openModal, setOpenModal] = useState(null);

  const dashboardUuid = useMemo(
    () => getDashboardUuidFromEnv(
      process.env.REACT_APP_SUPERSET_DASHBOARD_UUID_PREMIACAO,
      DEFAULT_DASHBOARD_UUID
    ),
    []
  );

  const { loading, data, error, reload, fetchGuestToken } = useSupersetDashboardToken(dashboardUuid);

  const handleCloseModal = () => {
    setOpenModal(null);
  };

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader routeSegments={[{ name: 'Início' }, { name: 'Dashboard' }, { name: 'Premiação' }]} />
        </Col>
      </Row>

      <Row className="flex-grow-1">
        <Col md={12} className="d-flex flex-column" style={{ minHeight: 'calc(100vh - 120px)' }}>
          <Card className="flex-grow-1 d-flex flex-column">
            <CardBody className="d-flex flex-column flex-grow-1 p-2">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex gap-2">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_TABELA)}
                  >
                    Tabelas de Premiação
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_FROTA)}
                  >
                    Frotas x Tabela
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_INFRACAO)}
                  >
                    Infrações
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_INFRACAO_MOTORISTA)}
                  >
                    Infrações x Motoristas
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_ASSOCIACAO)}
                  >
                    Associação
                  </Button>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setOpenModal(MODAL_CONSOLIDADO)}
                  >
                    Visualizar Premiação
                  </Button>
                </div>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={reload}
                  disabled={loading}
                  title="Atualizar dashboard"
                  aria-label="Atualizar dashboard"
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                  ) : (
                    <Icon name="refresh" size={18} />
                  )}
                </Button>
              </div>

              <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: 0 }}>
                {error || !data?.token ? (
                  <div className="text-muted">
                    {loading ? 'Carregando dashboard...' : 'Não foi possível carregar o dashboard.'}
                  </div>
                ) : (
                  <SupersetDashboardEmbed
                    instanceUrl={data.instanceUrl}
                    dashboardUuid={data.dashboardUuid}
                    fetchGuestToken={fetchGuestToken}
                    hideTitle
                    style={{ flex: 1, minHeight: 0, height: '100%' }}
                  />
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <PremiacaoTabelaModal show={openModal === MODAL_TABELA} onHide={handleCloseModal} />
      <PremiacaoTabelaVeiculoModal show={openModal === MODAL_FROTA} onHide={handleCloseModal} />
      <PremiacaoInfracaoModal show={openModal === MODAL_INFRACAO} onHide={handleCloseModal} />
      <PremiacaoInfracaoMotoristaDashboardModal show={openModal === MODAL_INFRACAO_MOTORISTA} onHide={handleCloseModal} />
      <PremiacaoConsolidadoModal show={openModal === MODAL_CONSOLIDADO} onHide={handleCloseModal} />
      <PremiacaoAssociacaoModal show={openModal === MODAL_ASSOCIACAO} onHide={handleCloseModal} />
    </Container>
  );
};

export default DashboardPremiacaoMain;
